<template>
    <div :class="$style.container" id="loading" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container>
            <div id="collectionHome">
                <el-row>
                    <el-col :span="14">
                        <div style="font-size: 18px;padding-top: 28px;font-weight: bold;">
                            提交进度报表
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="">
                        <el-form>
                            <el-row>
                                <el-col :span="12" style="text-align: left;margin-top:20px;">
                                    <span style="font-weight: bold;display: inline-block;width: 70px">任务列表</span>
                                    <el-select v-model="searchForm.task_id" placeholder="请选择任务"
                                        style="width: calc(100% - 160px)" clearable @change="handleTaskChange">
                                        <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                            :value="item.task_id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="12" style="text-align: right">
                                </el-col>
                            </el-row>
                        </el-form>
                        <el-row
                            style="margin-top:20px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                            <el-col :span="12">
                                <!-- <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button> -->
                                <el-button type="primary" size="small" icon="el-icon-download"
                                    @click.stop="handleDownloadCollectData('1')">导出代表填报进度</el-button>
                                <el-button type="primary" size="small" icon="el-icon-download"
                                    @click.stop="handleDownloadCollectData('2')">导出省平台提交进度</el-button>
                                <el-button type="primary" size="small" icon="el-icon-download"
                                    @click.stop="handleDownloadCollectData('3')">导出异常报表</el-button>
                            </el-col>
                            <el-col :span="12">
                                <!-- <div style="float: right;margin-right: 20px;">
                                    <el-button type="primary" size="small" icon="el-icon-download" @click.stop="handleDownloadCollectData">导出</el-button>
                                </div> -->
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
                <div style="margin-top: 20px;margin-bottom: 10px;">数据刷新时间:填报任务期间,进度数据每小时刷新</div>
                <div style="width: 100%;display: flex; align-items: center;">

                    <div style="padding-bottom: 50px;">
                        <el-card style="background-color: #c8dff2;border-radius:10px;height: 200px;">
                            <div style="padding: 5px;font-size: 22px;margin-top: 10px;">
                                代表整体填报进度
                            </div>
                            <div style="float: right;font-size: 48px;margin-top: 70px;font-weight: bold;">
                                {{customList.summary_obj.staff_report_progress}}%
                            </div>
                        </el-card>
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                            :data="customList.staff_array" border style="width: 100%;margin-top: 20px" stripe>
                            <el-table-column fixed type="index" width="55">
                            </el-table-column>
                            <el-table-column min-width="250" prop="territory_name" label="省平台">
                            </el-table-column>
                            <el-table-column min-width="150"  label="代表填报进度">
                                <template slot-scope="scope">
                                    {{ scope.row.staff_complate_rate }}%
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="padding-bottom: 50px;margin-left: 20px;">
                        <el-card style="background-color: #acceeb;border-radius:10px;height: 200px;">
                            <div style="padding: 5px;font-size: 22px;margin-top: 10px;">
                                省平台整体提交进度
                            </div>
                            <div style="float: right;font-size: 48px;margin-top: 70px;font-weight: bold;">
                                {{customList.summary_obj.manager_sumit_progress}}%
                            </div>
                        </el-card>
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                            :data="customList.manager_array" border style="width: 100%;margin-top: 20px" stripe>
                            <el-table-column fixed type="index" width="55">
                            </el-table-column>
                            <el-table-column min-width="250" prop="territory_name" label="省平台">
                            </el-table-column>
                            <el-table-column min-width="150" label="省平台提交进度">
                                <template slot-scope="scope">
                                    {{ scope.row.manager_submit_rate }}%
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="padding-bottom: 50px;margin-left: 20px;">
                        <el-card style="border-radius:10px;height: 200px;">
                            <div style="padding: 5px;font-size: 20px;margin-top: 10px;">
                               当周整体异常值情况
                            </div>
                            <el-row style="padding: 5px;font-size: 16px;background-color: #e7f2e0;">
                                <el-col :span="14">
                                    <div>校验正常</div>
                                </el-col>
                                <el-col :span="10">
                                    {{customList.summary_obj.rule_normal_rate}}%
                                </el-col>
                            </el-row>
                            <el-row style="padding: 5px;font-size: 16px;background-color: #f1f1f1;margin-top:5px;">
                                <el-col :span="14">
                                    <div>校验异常</div>
                                </el-col>
                                <el-col :span="10">
                                    {{customList.summary_obj.rule_exception_rate}}%
                                </el-col>
                            </el-row>
                            <el-row style="padding: 5px;font-size: 12px;" v-if="customList.summary_obj.rule_exception_1_rate>0">
                                <el-col :span="14">
                                    <div>{{showWeekValue(customList.summary_obj.rule_exception_1)}}</div>
                                </el-col>
                                <el-col :span="10">
                                    {{customList.summary_obj.rule_exception_1_rate}}%
                                </el-col>
                            </el-row>
                            <el-row style="padding: 5px;font-size: 12px;" v-if="customList.summary_obj.rule_exception_2_rate>0">
                                <el-col :span="14">
                                    <div>{{showWeekValue(customList.summary_obj.rule_exception_2)}}</div>
                                </el-col>
                                <el-col :span="10">
                                    {{customList.summary_obj.rule_exception_2_rate}}%
                                </el-col>
                            </el-row>
                            <el-row style="padding: 5px;font-size: 12px;" v-if="customList.summary_obj.rule_exception_3_rate>0">
                                <el-col :span="14">
                                    <div>{{showWeekValue(customList.summary_obj.rule_exception_3)}}</div>
                                </el-col>
                                <el-col :span="10">
                                    {{customList.summary_obj.rule_exception_3_rate}}%
                                </el-col>
                            </el-row>
                            <el-row style="padding: 5px;font-size: 12px;">
                                <el-col :span="24" >
                                    <div style="float: right;">仅展示校验异常TOP3的异常类型</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}"
                            :data="customList.exception_array" border style="width: 100%;margin-top: 20px" stripe>
                            <el-table-column fixed type="index" width="55">
                            </el-table-column>
                            <el-table-column min-width="250" prop="territory_name" label="省平台">
                            </el-table-column>
                            <el-table-column min-width="150" label="异常占比值">
                                <template slot-scope="scope">
                                    {{ scope.row.exception_rate }}%
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-container>
    </div>
</template>

<script>
    import axios from "axios";
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'

    import { Message } from "element-ui";
    import moment from 'moment'


    export default {
        name: "biCustomCollect",
        data() {
            return {
                loading: false,
                searchForm: {
                    task_id: "",
                },
                taskList: [],
                customList: {
                    "staff_array": [],
                    "manager_array": [],
                    "exception_array": [],
                    "summary_array": [],
                    "summary_obj": {
                        "staff_report_progress": "0",
                        "manager_sumit_progress": "0",
                        "rule_normal_rate": "",
                        "rule_exception_rate": "0",
                        "rule_exception_1": "",
                        "rule_exception_1_rate": "0",
                        "rule_exception_2": "",
                        "rule_exception_2_rate": "0",
                        "rule_exception_3": "",
                        "rule_exception_3_rate": "0"
                    }
                },
                week_array: [
                {
                        key: "week1",
                        label: "规则1【周】理论销售校验（批号）"
                    },
                    {
                        key: "week2",
                        label: "规则2【周】周累计销售异常校验(批号)"
                    },
                    {
                        key: "week3",
                        label: "规则3【周】四分位法识别异常值校验(批号)"
                    },
                    {
                        key: "week4",
                        label: "规则4【周】先进先出校验(批号)"
                    },
                    {
                        key: "week5",
                        label: "规则5【周】库存不动校验(批号)"
                    },
                    {
                        key: "week6",
                        label: "规则6【周】无库存异常(机构)"
                    },
                    {
                        key: "week7",
                        label: "规则7【周】批号异常(批号)"
                    },
                    {
                        key: "week8",
                        label: "规则8【周】期初校验(批号)"
                    },
                    {
                        key: "week9",
                        label: "规则16 【周】近效期校验(批号)"
                    },
                    {
                        key: "month1",
                        label: "规则9【月】理论销售异常(批号)"
                    },
                    {
                        key: "month2",
                        label: "规则10【月】先进先出异常(批号)"
                    },
                    {
                        key: "month3",
                        label: "规则11【月】无库存异常(机构)"
                    },
                    {
                        key: "month4",
                        label: "规则12【月】无后续采购异常(机构)"
                    },
                    {
                        key: "month5",
                        label: "规则13【月】销售异常(机构)"
                    },
                    {
                        key: "month6",
                        label: "规则14【月】库存天数异常(机构)"
                    },
                    {
                        key: "month7",
                        label: "规则15【月】首月填报期初校验(批号)"
                    },
                ],
                is_staff_false: true,
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                clientObj: {},
            }
        },
        components: {
            pagination,
        },
        methods: {
            showWeekValue(value) {
                let item = this.week_array.find(e => e.key === value)
                if (item) {
                    return item.label;
                }
                return "";
            },
            async getCollectTask() {
                let loading1 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        reference_obj: []
                    }
                    await http.post('/crm/web/collection/getCollectionTaskList', data).then(res => {
                        debugger
                        if (res.success) {
                            this.taskList = res.data.result
                            if (this.taskList.length > 0) {
                                this.searchForm.task_id = this.taskList[0].task_id
                            }
                            loading1.close()

                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    loading1.close()
                }

            },

            async getCollectionReportProgress() {
                this.loading = true;
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        task_id: this.searchForm.task_id
                    }
                    await http.post('/crm/web/collection/getCollectionReportProgress', data).then(res => {
                        console.log(res);
                        if (res.success) {
                            this.customList.staff_array = res.data.staff_array;
                            this.customList.manager_array = res.data.manager_array;
                            this.customList.exception_array = res.data.exception_array;
                            this.customList.summary_array = res.data.summary_array;
                            if (res.data.summary_array.length > 0) {
                                this.customList.summary_obj = res.data.summary_array[0];
                            } else {
                                this.customList.summary_obj = {
                                    "staff_report_progress": "0",
                                    "manager_sumit_progress": "0",
                                    "rule_normal_rate": "0",
                                    "rule_exception_rate": "0",
                                    "rule_exception_1": "",
                                    "rule_exception_1_rate": "0",
                                    "rule_exception_2": "",
                                    "rule_exception_2_rate": "0",
                                    "rule_exception_3": "",
                                    "rule_exception_3_rate": "0"
                                }
                            }


                            loading1.close()
                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    this.loading = false;
                }

            },

            handleTaskChange(val) {
                console.log(val)
                if (val) {
                    this.searchForm.task_id = val
                    this.getCollectionReportProgress()
                }
            },

            async handleDownloadCollectData(type) {
                this.loading = true;
                let params = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    user_id: this.$store.getters.getUser.user_id,
                    task_id: this.searchForm.task_id,
                    type: type
                }
                await axios({
                    method: "post",
                    url: "/wapi/derive/exportCollectionReportProgress",
                    data: params,
                    responseType: 'arraybuffer'
                    // responseType: "blob",
                })
                    .then((res) => {
                        console.log(res)
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                        }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
                        let file_name = "代表填报进度表.xlsx"
                        if(type=="2"){
                            file_name = "省平台提交进度表.xlsx"
                        }else if(type=="3"){
                            file_name = "异常值报表.xlsx"
                        }
                        const elink = document.createElement("a");
                        elink.download = file_name;
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                        this.loading = false;
                    })
                    .catch((e) => {
                        console.log(e);
                        this.loading = false;
                        this.$message.error("下载失败");
                    });
            },
        },
        async created() {

            if (this.$store.getters.getUser.role == 'staff') {
                this.is_staff_false = false
            }
            this.clientObj = this.$store.getters.getClient
            console.log(this.clientObj)

            await this.getCollectTask()
            await this.getCollectionReportProgress();

        },
        mounted() {

        },
        updated() {
        },
        beforeDestroy() {

        },
        computed: {

        },
        watch: {

        }
    }
</script>
<style lang="scss" module>
    .container {
        background: white;
        height: 100%;
        overflow: auto;

        .left {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            float: left;
            position: absolute;
            z-index: 1;

            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #555555;
                font-size: 20px;
            }

            .font {
                margin-left: 20px;
                font-size: 14px;
                color: #555555;
            }
        }

        .right {
            margin-top: -20px;
            width: 100%;

            .header {
                width: 100%;
                padding-bottom: 6px;
                border-bottom: 2px dotted #e7eaec;

            }

            .body {
                overflow: auto;

            }
        }

        .noData {}
    }
</style>
<style scoped>
    .el-container {
        height: 100%;
        padding: 20px;
        background: white;
    }

    #collectionHome {
        width: 100%;
        background: white;
        position: relative;
    }

    #collectionHome>>>.el-dialog__header {
        padding-top: 0
    }

    #collectionHome>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
    }

    #collectionHome>>>.el-tag.el-tag--info {
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }

    #collectionHome>>>.el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #collectionHome>>>.collectionHome_table_cell {
        color: #2b92fa !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/statement/components/LuoshiReportProgress.vue